import Bus from "@/lib/Bus"
import { IOpModifier, IOpOperacja, IOpParent } from "server/src/tree/mapper/op/IOp";
const bus: Bus = new Bus().getBus();
import { IOpServer, op_api } from "../../server/src/tree/mapper/op/IOpServer";
import { ITree } from "./ITree";
import { TreeSvc } from "./TreeSvc";


export class OpSvc implements IOpServer {

    parent:IOpParent|undefined
    vue:any
    
    constructor(parent: IOpParent | undefined, vue: any) {
        this.parent=parent
        this.vue = vue
    }
    
    async find_by_id(_id:any):Promise<IOpOperacja | undefined> {
        const ret = await bus.api(op_api.find_by_id, {id:_id})
        return ret;
    }

    async trees_to_operacje() {
        const ret = await bus.api(op_api.trees_to_operacje,{});
    }

    async del_operacje_for_prj(prj_id: any, physical: number) {
        const ret = await bus.api(op_api.del_operacje_for_prj,{prj_id: prj_id, physical: physical});
    }

    async del_operacje_for_tree(tree_id: any, physical: number) {
        const ret = await bus.api(op_api.del_operacje_for_tree,{tree_id: tree_id, physical: physical});
    }

    async del_operacje_for_lbl(lbl_id: any, physical: number) {
        const ret = await bus.api(op_api.del_operacje_for_lbl,{lbl_id: lbl_id, physical: physical});
    }

    async get_operacje(tree_id: any): Promise<IOpOperacja[]> {
        const ret = await bus.api(op_api.get_operacje,{tree_id:tree_id});
        return ret;
    }

    async save_changed(modified: IOpModifier[], operacje:IOpOperacja[]): Promise<IOpModifier[]> {

        console.log("OpSvc save_changed START")
        Bus.lock()
        if (!this.parent) return []

        const touched_new =  <IOpModifier[]> await bus.api(op_api.save_changed,{ modified: modified })
        modified[0].op._id = touched_new[0].op._id
        if (this.vue)  this.vue.$emit("operacje_changed",operacje)

        console.log("save END")
        Bus.unlock()
        return touched_new
        //return modified;
    }

}

